export const chunkArray = (arr, chunkSize) => {
  const res = []
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize)
    res.push(chunk)
  }
  return res
}

// TODO: Isn't this just Array.flat() ?
export const unChunkDataArray = (chunkedArray = []) => {
  return chunkedArray.reduce((r, chunk) => {
    if (chunk && chunk.data && chunk.data.length > 0) {
      return r.concat(chunk.data)
    }
    return r
  }, [])
}
